module.exports = __webpack_public_path__ + "static/Super-Fresh-Laundry-Lounge-6916-S-Western-Ave-Los-Angeles-CA-90047-40f67121b4776b39e885dc989dcc16b8.jpg";